import { getLinkPreloadTagsForDefinedElements } from "@webbloqs/elements/lib/global";

export const injectWebbloqsStyles = (): void => {
    getLinkPreloadTagsForDefinedElements().forEach(style => {
        document.head.innerHTML += style;
    });
};
